import { render } from "./FormPengeluaran.vue?vue&type=template&id=06c4a448"
import script from "./FormPengeluaran.vue?vue&type=script&lang=js"
export * from "./FormPengeluaran.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dev.pbf.infonetglobal.tech/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__